import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"
import { WalletBackup } from "./wallet-backup"
import WalletUnlock from "./wallet-unlock"
import { useState } from "react"
import { BackupMethods } from "@portal-hq/web"

interface WalletBackupModalProps {
  children: React.ReactNode;
  method: BackupMethods.gdrive | BackupMethods.passkey;
  onSkip?: () => void;
  onDone?: () => void;
}

export function WalletBackupModal({ children, method, onSkip, onDone }: WalletBackupModalProps) {
  const [isProcessing, setIsProcessing] = useState(false)
  const [open, setOpen] = useState(false)

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent
        className="sm:max-w-[425px]"
        onInteractOutside={(e) => isProcessing && e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Backup Wallet</DialogTitle>
          {!isProcessing && <DialogClose />}
        </DialogHeader>
        <WalletUnlock>
          <WalletBackup
            onProcessingChange={(processing) => setIsProcessing(processing)}
            method={method}
            onDone={() => {
              setOpen(false)
              onDone?.()
            }}
            onSkip={() => {
              setOpen(false)
              onSkip?.()
            }}
          />
        </WalletUnlock>
      </DialogContent>
    </Dialog>
  )
}
